import * as React from "react"

export default function SvgVerticalAlignTop(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="currentColor"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M5 5a.97.97 0 0 1-.713-.288A.97.97 0 0 1 4 4a.97.97 0 0 1 .287-.713A.97.97 0 0 1 5 3h14q.424 0 .712.287Q20 3.575 20 4q0 .424-.288.712A.97.97 0 0 1 19 5zm7 16a.97.97 0 0 1-.712-.288A.97.97 0 0 1 11 20v-9.2l-1.925 1.925A.92.92 0 0 1 8.4 13a.96.96 0 0 1-.7-.3.95.95 0 0 1-.275-.7q0-.425.275-.7l3.6-3.6q.15-.15.325-.212A1.1 1.1 0 0 1 12 7.425a1.1 1.1 0 0 1 .375.063.9.9 0 0 1 .325.212l3.625 3.625A.92.92 0 0 1 16.6 12q0 .4-.3.7a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275L13 10.8V20q0 .424-.287.712A.97.97 0 0 1 12 21" />
    </svg>
  )
}
